<template>
  <BaseEmptyTasklist class="empty-inbox">
    <template #text>
      <div>
        <p>The inbox contains all your unorganized items:</p>
        <p>
          <TaskIcon /> unplanned tasks, <NotesIcon /> untitled notes,
          <EventIcon /> unanswered meeting invitations and <NoticeIcon /> unread
          notices.
        </p>
      </div>
    </template>
  </BaseEmptyTasklist>
</template>
<script lang="ts">
import { defineComponent } from "vue";

import BaseEmptyTasklist from "@/components/base/BaseEmptyTasklist.vue";
import EventIcon from "@/components/icons/EventIcon.vue";
import NotesIcon from "@/components/icons/NotesIcon.vue";
import NoticeIcon from "@/components/icons/NoticeIcon.vue";
import TaskIcon from "@/components/icons/TaskIcon.vue";

export default defineComponent({
  components: { EventIcon, NoticeIcon, NotesIcon, TaskIcon, BaseEmptyTasklist },
});
</script>
<style scoped lang="scss">
.empty-inbox {
  p {
    margin: 0;
    display: flex;
    flex-direction: row;
    column-gap: 6px;
    align-items: center;
    justify-content: center;
    @extend %font-body-regular;
    text-align: center;
    @include themed() {
      color: t($grey-50);
    }
    .task-icon {
      display: inline-block;
    }
    svg {
      width: 102%;
    }
    svg,
    .task-icon,
    :deep(svg) {
      height: 14px;
      width: 14px;
    }
  }

  p + p {
    margin-top: 6px;
  }
}
</style>
